const badgeColors = {
    red: "ff0000",
    blue: "0000ff",
    green: "00872b",
    purple: "6600ff",
    yellow: "d9c709",
    orange: "d98609",
    darkBlue: "0f0080",
    deepPurple: "480087",
    teal: "008783",
    vueGreen: "42b883",
    hotPink: "ff36ee",
};

export default badgeColors;
